/**
 * Renders the entire page viewer component. Consists of multiple <Page>
 * components. Only renders the pages that are visible to the user.
 */
import React from "react";
import ReactDOM from "react-dom";
import Toc from "../documents/toc";
import Search from "../documents/search";
import Pages from "./pages";
import * as Utils from "../documents/utils";
import * as TocUtils from "../documents/toc_utils";
import * as TocBuilder from "../documents/toc_builder";
import * as UrlUtils from "../documents/url_utils";
import * as FavoriteAnimation from "../documents/favorite_animation";
import $ from "jquery";

export default class extends React.Component {
  constructor(props) {
    super(props);

    var permaLinkParams = {},
        hasPermaLink = false;

    if(!props.onlyShowDocumentList) {
      permaLinkParams = UrlUtils.getCurrentUrlParams() || {};
      hasPermaLink = permaLinkParams.d && permaLinkParams.p;
    }

    this.searchRequest = null;

    this.state = {
      loading: true,
      disabled: false,
      documents: null,
      fullToc: null,
      toc: null,
      favorites: null,
      searchResults: null,
      selectedDocument: null,
      pages: null,
      selectedSectionId: null,
      searchedTerms: "",
      highlightedTerms: [],
      initialPageNumber: 1,
      initialSearchTerms: "",
      initialSearchLoaded: false,
      permaLinkFollowed: !hasPermaLink,
      permaLinkParams: permaLinkParams,
      emptySearch: false,
      emptyToc: false,
      tocExpanded: false,
      searchLoading: false,
    };
  }

  /**
   * Is fired when component is rendered on page for first time
   */
  componentDidMount() {
    this.loadMetadata();
  }

  /**
   * Fires a disabled UI state after 1 sec of inactivity
   */
  setDisabledUI() {
    this.clearDisabledUI();
    this.disabledUITimeout = window.setTimeout(this.handleDisableUITimeout.bind(this), 1000);
  }

  /**
   * Removes disabled layer
   */
  clearDisabledUI() {
    this.clearDisabledUITimeout();
    this.setState({ disabled: false });
  }

  /**
   * Removes UI timer
   */
  clearDisabledUITimeout() {
    if(this.disabledUITimeout) {
      window.clearTimeout(this.disabledUITimeout);
      this.disabledUITimeout = null;
    }
  }

  /**
   * Is fired when UI should be disabled
   */
  handleDisableUITimeout() {
    this.clearDisabledUITimeout();
    this.setState({ disabled: true });
  }

  /**
   * Retrieves document metadata
   */
  loadMetadata() {
    $.ajax({
      url: this.props.metadataUrl,
      method: "GET",
      cache: false
    }).then(
      (data) => {
        this.handleMetadataLoaded(data);
      },
      (data) => {
        Utils.handleError(data);
      }
    );
  }

  /**
   * Retrieves search results
   */
  loadSearchResults(terms) {
    if(this.searchRequest && this.searchRequest.readyState != 4) {
      this.searchRequest.abort();
      this.searchRequest = null;
    }

    this.setState({ searchLoading: true });

    this.searchRequest = $.ajax({
      url: this.props.searchUrl,
      data: { query: terms },
      method: "GET",
      cache: false
    });

    this.searchRequest.then(
      (data) => {
        this.setState({ searchLoading: false });

        this.searchRequest = null;
        this.handleSearchResultLoaded(data);
      },
      (data) => {
        Utils.handleError(data);

        this.setState({ searchLoading: false });
        this.searchRequest = null;
      }
    );
  }

  /**
   * Is fired when meta data is successfully loaded
   */
  handleMetadataLoaded(data) {
    console.log(data)
    // @TODO Kill me
    data.whitepapers.forEach(function(document) { document.isWhitepaper = true; });
    data.documents = data.documents.concat(data.whitepapers);

    var toc = TocBuilder.build(data.documents, data.favorites, null);

    var document, pages, shouldLoadSearch, initialSelectedSectionId,
        initialPageNumber, initialSearchTerms;

    if(data.documents.length == 0) {
      this.setState({ loading: false, emptyToc: true });
      return;
    }

    // check if we have a permalink
    if(this.state.permaLinkFollowed) {
      // just grab the first one
      document = data.documents[0];
      pages = document.pages;

      initialSelectedSectionId = TocUtils.getFirstSectionWithDocument(toc).id;
      initialPageNumber = 1;
      initialSearchTerms = "";

      // no need for extra search result
      shouldLoadSearch = false;

    } else {
      // follow perma link
      document = TocUtils.getDocument(data.documents, this.state.permaLinkParams.d);

      if(!document) {
        document = data.documents[0];
        // TODO: FIXME
        // Flash.setMessage("error", "Could not find the requested document");
      }

      pages = document.pages;
      shouldLoadSearch = this.state.permaLinkParams.q ? true : false;
      initialPageNumber = this.state.permaLinkParams.p;
      initialSearchTerms = this.state.permaLinkParams.q || "";

      let initialSelectedSection = TocUtils.getSectionFromPage(toc, document.id, initialPageNumber);
      initialSelectedSectionId = initialSelectedSection ? initialSelectedSection.id : null;
    }

    // set the documents and set the first document to view
    this.setState({
      loading: shouldLoadSearch,
      favorites: data.favorites,
      documents: data.documents,
      toc: toc,
      fullToc: toc,
      selectedDocument: document,
      pages: pages,
      initialPageNumber: initialPageNumber,
      selectedSectionId: initialSelectedSectionId,
      initialSelectedSectionId: initialSelectedSectionId,
      initialSearchTerms: initialSearchTerms,
      permaLinkFollowed: !shouldLoadSearch
    });

    // Does permalink contain o we have an initial search query?
    if(shouldLoadSearch) {
      // go get 'm
      this.loadSearchResults(this.state.permaLinkParams.q);
    }
  }

  /**
   * Is fired when search results are loaded
   */
  handleSearchResultLoaded(data) {
    // build up new toc with search data
    var toc, documentIds, selectedDocument, highlightedTerms,
        initialPageNumber, initialSelectedSectionId;

    highlightedTerms = data.search.matches || [];

    // retrieve document ids that are found in search
    documentIds = TocUtils.getMatchingDocumentIdsForSearchResults(this.state.documents, data.search);

    // check if we have any hits
    if(data.search.hits.length == 0 || documentIds.length == 0) {
      // nope!
      this.handleSearchReset();
      this.setState({ emptySearch: true, loaded: true });
      return;
    }

    // build new toc with the search data
    toc = TocBuilder.build(this.state.documents, this.state.favorites, data.search);

    // did we already follow the permalink?
    if(this.state.permaLinkFollowed) {
      // just grab the first doc from the search results
      let firstSection = TocUtils.getFirstSectionWithDocument(toc);

      selectedDocument = TocUtils.getDocument(
        this.state.documents,
        firstSection.documentId
      );

      initialPageNumber = TocUtils.getPageNumberFromSectionWithSearchResults(
        data.search,
        firstSection
      );

      initialSelectedSectionId = firstSection.id;

    } else {
      // nope, permalink not followed yet, grab the one from the URL
      selectedDocument = TocUtils.getDocument(
        this.state.documents,
        this.state.permaLinkParams.d
      );

      initialPageNumber = this.state.permaLinkParams.p;

      let initialSelectedSection = TocUtils.getSectionFromPage(toc, selectedDocument.id, initialPageNumber);
      initialSelectedSectionId = initialSelectedSection ? initialSelectedSection.id : null;
    }

    if(!this.props.onlyShowDocumentList) {
      UrlUtils.setUrlParams({
        p: initialPageNumber,
        d: selectedDocument.id
      });
    }

    this.setState({
      searchResults: data.search,
      searchedTerms: data.search.terms,
      permaLinkFollowed: true,
      toc: toc,
      loading: false,
      initialPageNumber: initialPageNumber,
      selectedDocument: selectedDocument,
      highlightedTerms: highlightedTerms,
      pages: selectedDocument.pages,
      initialSelectedSectionId: initialSelectedSectionId,
      selectedSectionId: initialSelectedSectionId,
      emptySearch: false
    });
  }

  /**
   * Is fired when section is opened in toc
   */
  handleSectionOpenWhenOnlyShowingDocumentList(section) {
    var numberOfChildren = TocUtils.getSectionsForParentId(this.state.fullToc, section.id).length;

    this.setState({ selectedSectionId: section.id });

    // we're not interested in root sections
    if(section.level <= 1 && numberOfChildren > 0) return;

    var url = `${this.props.documentUrl}#/?d=${section.documentId}`;

    // do we have search results?
    if(this.state.searchResults && !this.emptySearch) {
      // get page number within section for search
      let pageNumber = TocUtils.getPageNumberFromSectionWithSearchResults(
        this.state.searchResults,
        section
      );

      // translate to sub-section
      let subSection = TocUtils.getSectionFromPage(
        this.state.fullToc,
        section.documentId,
        pageNumber
      );

      url += `&q=${this.state.searchResults.terms}&p=${pageNumber}`;

    } else {
      url += `&p=${section.startPageNumber}`;
    }

    //console.log(url);

    // redirect
    window.location = url;
  }

  /**
   * Is fired when section is opened in toc
   */
  handleSectionOpenWhenShowingPages(section, metadata) {
    console.log(section, metadata)
    var state = { selectedSectionId: section.id },
        pages = this.state.pages;

    if(!section.documentId) return;

    // did the document change?
    if(this.state.selectedDocument.id != section.documentId) {
      // if so, change the selectedDocument
      state.selectedDocument = TocUtils.getDocument(
        this.state.documents,
        section.documentId
      );

      // grab it's filtered pages when user has searched
      pages = state.selectedDocument.pages;

      // set new set of pages to state
      state.pages = pages;
    }

    // do we have any search results?
    if(!section) {
      state.initialPageNumber = 1;

    } else if(this.state.searchResults) {
      state.initialPageNumber = TocUtils.getPageNumberFromSectionWithSearchResults(
        this.state.searchResults,
        section
      );

    } else {
      state.initialPageNumber = section.startPageNumber;

    }

    if(metadata == "close")
      state.tocExpanded = false;

    UrlUtils.setUrlParams({
      d: section.documentId,
      p: state.initialPageNumber
    });

    this.setState(state);
  }

  /**
   * Handles search terms
   */
  handleSearch(terms) {
    // set URL for permalink
    if(!this.props.onlyShowDocumentList) {
      UrlUtils.setUrlParams({ q: terms });
    }

    this.loadSearchResults(terms);
  }

  /**
   * Is fired when search terms changed but are not definitive yet
   */
  handleSearchChange() {
    this.setState({ searchLoading: true });
  }

  /**
   * Removes search
   */
  handleSearchReset() {
    var state = {
          emptySearch: false,
          highlightedTerms: [],
          searchResults: null,
          toc: TocBuilder.build(this.state.documents, this.state.favorites)
        };

    // do we have a selected section?
    if(this.state.selectedSectionId) {
      let selectedSectionId = TocUtils.getOriginalSectionIdFromSearchToc(
        this.state.toc,
        this.state.selectedSectionId
      );

      if(selectedSectionId) {
        state.selectedSectionId = selectedSectionId;
        state.initialSelectedSectionId = selectedSectionId;
      }
    }

    if(!this.props.onlyShowDocumentList) {
      UrlUtils.setUrlParams({ q: "" });
    }

    this.setState(state);
  }

  /**
   * Fires when user scrolls
   */
  handleMostVisiblePageChange(page) {
    if(!this.props.onlyShowDocumentList) {
      UrlUtils.setUrlParams({
        p: page.pageNumber,
        d: this.state.selectedDocument.id
      });
    }
  }

  /**
   * Fires when user adds new favorite
   */
  handleFavoriteClick(page, event) {
    var animationSpawnPointElement = $(event.currentTarget),
        method;

    this.setDisabledUI();

    if(this.state.favorites.indexOf(page.id) == -1) {
      method = "POST";
    } else {
      method = "DELETE";
    }

    $.ajax({
      url: this.props.favoriteUrl.replace("0", page.id),
      method: method,
      cache: false
    }).then(
      (data) => {
        this.clearDisabledUI();
        this.handleFavoriteSaved(page, animationSpawnPointElement, data.isFavorite);
      },
      (data) => {
        this.clearDisabledUI();
      }
    );
  }

  /**
   * Is fired when favorite is saved
   */
  handleFavoriteSaved(page, animationSpawnPointElement, isFavorite) {
    if(isFavorite)
      FavoriteAnimation.spawnAnimation(animationSpawnPointElement);

    var favorites = this.state.favorites;

    // update the original object
    page.isFavorite = isFavorite;

    // is a favorite?
    if(isFavorite) {
      // only push when needed
      if(favorites.indexOf(page.id) == -1)
        favorites.push(page.id);
    } else {
      // only remove when needed
      if(favorites.indexOf(page.id) != -1)
        favorites.splice(favorites.indexOf(page.id), 1);
    }

    // rebuild toc
    var toc = TocBuilder.build(
      this.state.documents,
      favorites,
      this.state.searchResults && !this.state.emptySearch ? this.state.searchResults : null
    );

    // trigger re-render
    this.setState({ toc: toc, favorites: favorites });
  }

  /**
   * Is fired when the mobile toc expander button is clicked
   */
  handleTocExpanderClick(event) {
    event.preventDefault();
    this.setState({ tocExpanded: !this.state.tocExpanded });
  }

  renderSearchResultCount() {
    var message;

    if(!this.state.emptySearch && this.state.searchResults) {
      let message;

      if(this.state.searchResults.hits.length > TocBuilder.MAX_SEARCH_RESULTS) {
        message = `Too many results, showing first 100`;

      } else {
        message = `Found ${this.state.searchResults.hits.length} matching pages`;

      }

      return (
        <div className="document-viewer-toc-searchcount">
          {message}
        </div>
      );
    } else {
      return null;
    }
  }

  // @TODO Should be moved into multiple functions or maybe even components
  render() {
    var docBrowser,
        pages,
        disabledLayer,
        tocExpander;

    // only render search, toc and pages when not loaded
    if(!this.state.loading) {
      let toc,
          className = "document-viewer-toc",
          searchCount;

      if(this.state.emptySearch) {
        toc = (
          <div className="document-viewer-toc-empty">
            No results
          </div>
        );

      } else if(this.state.emptyToc) {
        toc = (
          <div className="document-viewer-toc-empty">
            There are no documents for this asset
          </div>
        );

      } else {
        let sectionHandler;

        if(this.props.onlyShowDocumentList) {
          sectionHandler = this.handleSectionOpenWhenOnlyShowingDocumentList.bind(this);
        } else {
          sectionHandler = this.handleSectionOpenWhenShowingPages.bind(this);
        }

        toc = (
          <Toc
            toc={this.state.toc}
            onSectionOpen={sectionHandler}
            initialSelectedSectionId={this.state.initialSelectedSectionId}>
            {this.renderSearchResultCount()}
          </Toc>
        );
      }

      tocExpander = (
        <a
          href="#"
          className="d-block d-sm-none document-viewer-toc-expander"
          onClick={this.handleTocExpanderClick.bind(this)}>
          Table of contents
        </a>
      );

      if(this.state.emptyToc) {
        if(this.props.onlyShowDocumentList) {
          docBrowser = toc;
        } else {
          docBrowser = (
            <div className={className}>
              {toc}
            </div>
          );
        }

      } else {
        docBrowser = (
          <div className={className}>
            <Search
              initialSearchTerms={this.state.initialSearchTerms}
              loading={this.state.searchLoading}
              onSearchChange={this.handleSearchChange.bind(this)}
              onSearch={this.handleSearch.bind(this)}
              onReset={this.handleSearchReset.bind(this)}
            />
            {toc}
          </div>
        );
      }

      if(!this.state.emptyToc && !this.props.onlyShowDocumentList) {
        pages = (
          <Pages
            key={`pages-${this.state.selectedDocument.id}-${this.state.searchedTerms}`}
            pages={this.state.pages}
            favorites={this.state.favorites}
            debug={this.props.debug}
            allowDownload={this.props.allowDownload}
            allowShare={this.props.allowShare && !this.state.selectedDocument.isWhitepaper}
            downloadUrl={this.state.selectedDocument.downloadPath}
            onFavoriteClick={this.handleFavoriteClick.bind(this)}
            onMostVisiblePageChange={this.handleMostVisiblePageChange.bind(this)}
            initialPageNumber={this.state.initialPageNumber}
            highlightedTerms={this.state.highlightedTerms} />
          );
      }
    }

    if(this.state.disabled) {
      disabledLayer = (
        <div className="document-viewer-disabled-layer" />
      );
    }

    if(this.props.onlyShowDocumentList) {
      return (
        <div>
          {docBrowser}
        </div>
      );

    } else {
      return (
        <div className={`row document-viewer-row ${this.state.tocExpanded ? "document-viewer-row--toc-expanded" : ""}`}>
          <div className="col-lg-3 col-md-3 document-viewer-col document-viewer-col--left">
            {tocExpander}
            {docBrowser}
          </div>

          <div className="col-lg-9 col-md-9 document-viewer-col document-viewer-col--right">
            {pages}
          </div>

          {disabledLayer}
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./app/javascript/portal/document_viewer/base.jsx